// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Qz27","inputDescription":"styles_inputDescription__3jjW3"};